The identifier for the `PositionProfile` to be updated.

This field should only be provided when updating an existing `PositionProfile`.
Passing the `profileId` of an expired `PositionProfile` will result in an error.
